"use client";

import Link from "next/link";
import { SiteFooter, SiteHeader } from "@/components/site-chrome";
import { usePrefs } from "@/components/prefs-provider";

export default function PrivacyPage() {
  const { t } = usePrefs();
  return (
    <div className="min-h-screen bg-[var(--bg)]">
      <SiteHeader solid />
      <main className="prose mx-auto max-w-3xl px-4 py-28 sm:px-6">
        <h1 className="font-display text-4xl font-bold">{t.legal.privacy}</h1>
        <p className="text-[var(--ink-soft)]">{t.legal.privacyP}</p>
        <Link href="/" className="text-[var(--teal)]">
          ← {t.legal.back}
        </Link>
      </main>
      <SiteFooter />
    </div>
  );
}
